import React from "react";
import { Badge, Button, Col, Container, Jumbotron, Row } from "react-bootstrap";
import SVG from "react-inlinesvg";
import classNames from "classnames";
import teamsIcon from "../../../../assets/images/icon-teams.svg";

import css from "./TeamHeading.module.css";
import { FormattedMessage } from "react-intl";

interface TeamHeadingProps {
  teamName: string;
}

const TeamHeading = ({ teamName }: TeamHeadingProps) => {
  return (
    <Jumbotron fluid className={css.root}>
      <Container fluid>
        <Row>
          <Col md={12} xl={7}>
            <div className="d-md-flex align-items-center mb-5">
              <span className="svg-icon mr-4">
                <SVG src={teamsIcon} />
              </span>
              <h1
                className={classNames(
                  css.title,
                  "m-0 text-uppercase font-weight-boldest font-size-h3"
                )}
              >
                {teamName}
              </h1>
              <Badge variant="light" className="mt-3 mt-md-0 ml-md-3">
                <FormattedMessage id="TEAM.HEADING.TEAM_BADGE" />
              </Badge>
            </div>
          </Col>
        </Row>
      </Container>
    </Jumbotron>
  );
};

export default TeamHeading;
